module.exports = __webpack_public_path__ + "files/9a165813b15127a52ffa38789a006026.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-57x57.png
// module id = 565
// module chunks = 60